<template>
  <label
    :for="`checked-toggle-${id}`"
    class="relative inline-flex h-fit w-fit cursor-pointer items-center rounded-full border border-neutral-100 py-[0.125rem] px-[0.125rem] text-secondary-500"
  >
    <input
      v-if="!loading"
      :id="`checked-toggle-${id}`"
      :checked="value"
      :disabled="disabled"
      type="checkbox"
      class="peer sr-only"
      @input="(event) => toggle(event.target?.checked)"
    />

    <span
      v-if="!loading"
      class="peer h-4 w-[38px] rounded-full bg-neutral-75 text-xs after:absolute after:left-[0.125rem] after:h-4 after:w-4 after:rounded-full after:bg-neutral-400 after:transition-[transform,background-color] after:duration-150 after:ease-out-quart after:content-[''] peer-checked:after:translate-x-[22px] peer-checked:after:bg-secondary-500"
    />

    <InfuseSpinner v-if="loading" size="small" />
  </label>
</template>

<script lang="ts" setup>
import InfuseSpinner from './InfuseSpinner.vue';

const emit = defineEmits(['update:modelValue', 'on', 'off']);

interface Props {
  id: string;
  value: boolean;
  disabled?: boolean;
  loading?: boolean;
}

defineProps<Props>();

function toggle(checked: boolean) {
  emit('update:modelValue', checked);
  checked ? emit('on') : emit('off');
}
</script>
